import { createChainedFunction } from '@mui/material';
import { APIInverterSearch } from './Api';

function isEmpty(obj) {

    // null and undefined are "empty"
    if (obj === null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

export async function CalcInverters(ri_in, battery, panelArrays,offerid, is3phase,  offgrid) {
    // Get the Solar Panel Output 
    if(!Array.isArray(panelArrays) || panelArrays.length == 0) {
        return
    }
    var totalsize = 0 
    // See if we are using Solar Edge
    var solaredge=false
    var prefmanufacturer = ""
    var og = offgrid
    if(typeof og == "undefined")
        og = false
    if(offerid == "7 Day Offer 2") 
        prefmanufacturer = ""

    for(var i=0; i<panelArrays.length; i++) {
        if(typeof panelArrays[i].optimiser !== "undefined" && panelArrays[i].optimiser.type == "SE")
            solaredge = true
            totalsize += (panelArrays[i].watts * panelArrays[i].numPanels)    
    }

    if(battery && typeof battery !== "undefined" && battery.manufacturer.toUpperCase() == "SOLAREDGE")
        solaredge = true


    var spw = Math.round(totalsize)
    if(typeof spw == "undefined" || !spw || spw <= 0  ) {
        return {status: false,            
                errOpen: true,
                calculating: false, 
                errText: "The Solar Panel size is showing as Zero or un-calculated. Please Press the 'Calculate Savings' Button and see if this fixes the probelm",
                errTitle: "Cannot Canulate Required Inverters"
    
        }
    }

    // Calculate number of inverters required and sizes
    var totinv = 0
    var l_inverters = []
    var inc_search = 0
    var inc_search_to = 0

    if(is3phase === "undefined" )
        is3phase  = false
    let mult = 1.15

    if( spw <=3600 ) 
        mult = 1.25
    else if( spw <=5000)
        mult = 1.3
    else if(spw <= 8000)
        mult = 1.3334
    
    const hmax = (6000 * 1.3334)
    if(spw > 6000 ) {
        if(og) {
            totinv = spw
            l_inverters.push({overwrite: true ,from: spw/1.3334, to: spw, hybrid: true, solaredge,is3phase,offgrid: og, inverter: {},prefmanufacturer})    
        }else if(is3phase ) {
            totinv = (spw*1.3)
            l_inverters.push({overwrite: true, from: (spw/1.3), to: (spw*1.3), hybrid: true, solaredge,is3phase,offgrid: og, inverter: {},prefmanufacturer})   
        }else if(!is3phase && !solaredge) {
            totinv = 6000   // hmax 
            totinv = 6000 * 1.3;
            l_inverters.push({overwrite: true, from: 6000, to: hmax, hybrid: true, solaredge,is3phase,offgrid: og, inverter: {},prefmanufacturer})    
        }else if(solaredge ==true ) {
            if(spw > 10000) totinv = 10000
            else totinv = spw
            l_inverters.push({overwrite: true, from: hmax, to: 12000, hybrid: false, solaredge: true,is3phase,offgrid: offgrid, inverter: {},prefmanufacturer})    
        }else {
            totinv = 0
        }
        // We require more than one inverter
        while(totinv < spw) {
            if( (spw-totinv) <=3600 ) 
                mult = 1.25
            else if( (spw-totinv) <=5000)
                mult = 1.3
            else if( (spw-totinv) <= 8000)
                mult = 1.3334
            
            inc_search = parseInt((spw - totinv) / mult)
            inc_search_to = parseInt(((spw - totinv) * mult) + 0.5) // Takes care of division rounding
            l_inverters.push({overwrite: true, from: inc_search, to: inc_search_to,hybrid: false,solaredge,is3phase,offgrid: offgrid, inverter:{},prefmanufacturer})
            totinv += inc_search_to
        }
    }else {
        if(solaredge)
            l_inverters.push({overwrite: true, from: (spw/mult), to: (spw*mult), hybrid: false, solaredge, is3phase,offgrid: offgrid,inverter: {},prefmanufacturer})
        else
            l_inverters.push({overwrite: true, from: (spw/mult), to: (spw*mult), hybrid: true, solaredge, is3phase,offgrid: offgrid,inverter: {},prefmanufacturer})
    }
    try {
        for(var i=0; i<l_inverters.length; i++) {
            const pinv = l_inverters[i]
            var iCnt = 0
            while( isEmpty(pinv.inverter) && iCnt < 10  ) {
                let inv = await APIInverterSearch(pinv)
                if(typeof inv !== "undefined" && inv && inv.length > 0) {
                    if(inv.length > 0 ){
                        // If we have a battery lets try and  match the battery to the Inverter
                        if(battery && typeof battery !== "undefined") {
                            let batmanu = battery.manufacturer.toUpperCase();
                            let batmanubefore = batmanu
                            if(batmanu == "FOX" && battery.highvoltage == false)
                                batmanu = "SOLIS"
                            var bmatch = false
                            for(var b=0; b<inv.length; b++) {
                                if( inv[b].manufacturer.toString().toUpperCase().search(batmanu) >=0 ) {
                                    bmatch = false
                                    try {
                                        const tinv = JSON.parse(JSON.stringify(inv[b]))
                                        if(tinv.highvoltage == battery.highvoltage) {
                                            l_inverters[i].inverter = tinv
                                            b = inv.length;
                                            bmatch = true;
                                            break;
                                        }
                                    }catch(err) {
                                        console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)
                                    }
                                }    
                            }
                            if(!bmatch) {
                                l_inverters[i].inverter = JSON.parse(JSON.stringify(inv[0]))
                            }
                            // If not we will just take the first one returned.
                        }else {
                            try {
                                l_inverters[i].inverter = JSON.parse(JSON.stringify(inv[0]))
                            }catch(err) {      
                            console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)
                            }
                        }
                    }else
                        try {
                            l_inverters[i].inverter = JSON.parse(JSON.stringify(inv[0]))
                        }catch(err) {
                            console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)

                        }
                }else { 
                    if(pinv.prefmanufacturer == "SOFAR") {
                        pinv.prefmanufacturer = "SOAFR"
                        let inv = await APIInverterSearch(pinv)
                        if(typeof inv !== "undefined" && inv) {
                            if(inv.length > 1 ){
                                // If we have a battery lets try and  match the battery to the Inverter
                                if(battery && typeof battery !== "undefined") {
                                    let batmanu = battery.manufacturer.toUpperCase();
                                    let batmanubefore = batmanu
                                    if(batmanu == "FOX" && battery.highvoltage == false)
                                        batmanu = "SOLIS"
                                    var bmatch = false
                                    for(var b=0; b<inv.length; b++) {
                                        if(inv[b].manufacturer.toString().toUpperCase().search(batmanu) > 0  ) {
                                            bmatch = false
                                            try{                                                                                            const tinv = JSON.parse(JSON.stringify(inv[b]))
                                                if(tinv.highvoltage == battery.highvoltage) {
                                                    l_inverters[i].inverter = tinv
                                                    b = inv.length;
                                                    bmatch = true
                                                    break;  
                                                }
                                            }catch(err){
                                                console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)
                                            } 
                                        }    
                                    }
                                    if(!bmatch) {  
                                        try{
                                            l_inverters[i].inverter = JSON.parse(JSON.stringify(inv[0]))
                                        }catch(err){
                                            console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)
                                        }
                                    }
                                    // If not we will just take the first one returned.
                                }else {
                                    try{
                                        l_inverters[i].inverter = JSON.parse(JSON.stringify(inv[0]))
                                    }catch(err) {
                                        console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)
                                    }
                                }
                            }else {

                                try{
                                    l_inverters[i].inverter = JSON.parse(JSON.stringify(inv[0]))
                                }catch(err) {
                                    console.log(`Catch Error setting inverter[${i}] to JSON parse ${inv[0]}`)
                                    
                                }
                            }
    
                        }
                    }
                }

                iCnt++;
                if(isEmpty(l_inverters[i].inverter)  && iCnt < 15) {
                    l_inverters[i].to = l_inverters[i].to +100;
                }
                else if(isEmpty(l_inverters[i].inverter)  && iCnt >= 5) {
                    l_inverters[i].from = l_inverters[i].from * 1.05
                }
            }
        }
    } catch(err) {        
        console.log(`Catch Error in Loop i = [${i}] `)
        console.log(err)

    }
    // Restore any inverters that had an overwrite set to false
try {
    if(typeof ri_in !== "undefined" && ri_in.length > 0 ) {
        for(let i=0; i<ri_in.length; i++) {
            if(!ri_in[i].overwrite && typeof ri_in[i].inverter !== "undefined" && typeof ri_in[i].inverter.id !== "undefined") {
                l_inverters[i] = JSON.parse(JSON.stringify(ri_in[i])) 
            }
        }
    }
    const lic = JSON.parse(JSON.stringify(l_inverters))
    for(let i=0; i<l_inverters.length; i++) {
        const curinv = l_inverters[i];
        if(typeof  curinv.inverter !== "undefined" && typeof curinv.inverter.id == "undefined") {
            l_inverters[i].to = parseInt((spw/2)/1.15);
            l_inverters[0].to = parseInt(spw*1.3)
            l_inverters[0].from = parseInt(spw/2);
            if(i>0) {
                l_inverters[i].hybrid = false;
                if( l_inverters[i].to <1000) {
                    l_inverters[i].inverter.id = -2
                    l_inverters[i].description ='No Inverter Required'
                }
            }
        }else {
            // Future work split into two inverters
            //l_inverters[0].from = parseInt((spw/2)/1.15);
        }
    }
    //if(l_inverters.length == 1 && typeof l_inverters[0].inverter.id == "undefined" && l_inverters[0].hybrid)
    //    l_inverters[0].hybrid = false
}catch(err) {
    console.log(`Exception Error ${err}`)
    console.log(err)
}

    return {status: true, required_inverters: JSON.parse(JSON.stringify(l_inverters)) }
}

export async function CalcInvertersV2(battery, panelArrays,offerid, is3phase,  offgrid) {
}
